import React from 'react'
import { styled } from 'linaria/react'
import { useTranslation } from '@/hooks/I18nProvider'

const DialogContainer = styled.div`
  @apply fixed inset-0 z-50 transition-opacity duration-300 ease-in-out;

  &.visible {
    @apply opacity-100 pointer-events-auto;
  }
  &.hidden {
    @apply opacity-0 pointer-events-none;
  }
`

const Backdrop = styled.div`
  @apply absolute w-full h-full bg-black bg-opacity-50;
`

const Panel = styled.div`
  @apply absolute bottom-0 left-0 right-0 bg-white rounded-t-xl overflow-y-auto;
  
  min-height: 50vh;
  max-height: 90vh;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  
  @apply transition-transform duration-300 ease-in-out;
  transform: translateY(100%);

  &.open {
    transform: translateY(0);
  }
`

const DialogHeader = styled.header`
  @apply flex items-center justify-center relative p-4 md:hidden;
`

const Title = styled.h2`
  @apply font-semibold text-gray-800;
`

const CloseButton = styled.button`
  @apply absolute left-4 w-8 h-8 z-10 bg-white cursor-pointer text-gray-700;
`

const SidebarDialog = ({ show, onClose, children }) => {
  const { t } = useTranslation()

  return (
    <DialogContainer className={show ? 'visible' : 'hidden'}>
      <Backdrop onClick={onClose} />
      <Panel className={show ? 'open' : ''}>
        <DialogHeader>
          <CloseButton type="button" onClick={onClose} aria-label="Close payment details">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </CloseButton>
          <Title>{t`paymentDetails.title`}</Title>
        </DialogHeader>
        {children}
      </Panel>
    </DialogContainer>
  )
}

export default SidebarDialog
